import config from '@blueberry/config';
const {
  SNAPASK_SITE_ENDPOINT,
  SNAPASK_QA_ROOT_PATH: SNAPASK_QA_SITE_ENDPOINT,
} = config;

import { getLocaleCode as getAppLocale } from '@blueberry/redux/locale';

import {
  generateURL,
  generateURLWithoutLocale,
} from '@blueberry/utils/navigation';

const action = actionName => `NAV:${actionName}`;

export const HOME = action('HOME');
export const LANDING_PAGE = action('LANDING_PAGE');
export const CAMPAIGN_RESULT = action('CAMPAIGN_RESULT');
export const EXTERNAL_URL = action('EXTERNAL_URL');
export const LANDING_PAGE_WITH_RETURN = action('LANDING_PAGE_WITH_RETURN');
export const CAMPAIGN_PAGE = action('CAMPAIGN_PAGE');
export const DASHBOARD_SCORERECORD_LIST = action('DASHBOARD_SCORERECORD_LIST');
export const STUDENT_DETAIL_PAGE = action('STUDENT_DETAIL_PAGE');
export const WIZMO_PAGE = action('WIZMO_PAGE');
export const ACADEMY_PAGE = action('ACADEMY_PAGE');

export const home = () => ({
  type: HOME,
});

export const goToLandingPage = path => ({
  type: LANDING_PAGE,
  payload: {
    path,
  },
});

export const goToAcademyPage = name => ({
  type: ACADEMY_PAGE,
  payload: {
    name,
  },
});

export const campaignResultPage = name => ({
  type: CAMPAIGN_RESULT,
  payload: {
    name,
  },
});

export const goToExternalUrl = (url, newTab = false) => ({
  type: EXTERNAL_URL,
  payload: {
    url,
    newTab,
  },
});

export const goToLandingPageWithReturn = (path, returnUrl) => ({
  type: LANDING_PAGE_WITH_RETURN,
  payload: {
    path,
    returnUrl,
  },
});

export const campaignPage = name => ({
  type: CAMPAIGN_PAGE,
  payload: {
    name,
  },
});

export const goToDashboardScoreRecordList = () => ({
  type: DASHBOARD_SCORERECORD_LIST,
});
export const goToStudentScoreRecordPage = ({
  studentId,
  semesterId,
  subjectId,
  classId,
  recordId,
}) => ({
  type: STUDENT_DETAIL_PAGE,
  payload: {
    studentId,
    semesterId,
    subjectId,
    classId,
    recordId,
  },
});

export const goToWizmoPage = path => ({
  type: WIZMO_PAGE,
  payload: {
    path,
  },
});

export const generateOfficialSiteURL = state => {
  const locale = getAppLocale(state);
  return (path, params) =>
    generateURL({ path, baseUrl: SNAPASK_SITE_ENDPOINT, params, locale });
};

export const generateAcademyURL = state => {
  const locale = getAppLocale(state);
  return (path, params) => generateURL({ path, params, locale });
};

export const generateQuestionAskURL = () => {
  return (path, params) =>
    generateURLWithoutLocale({
      path,
      baseUrl: SNAPASK_QA_SITE_ENDPOINT,
      params,
    });
};

export const generatePostURL = state => {
  const getAcademyURL = generateAcademyURL(state);
  return params => getAcademyURL('/post/:title-:id', params);
};



// WEBPACK FOOTER //
// ./app/redux/navigation.js